import { ReductionType } from 'AppEnums';
import { AxiosResponse } from 'axios';
import { apiInstance } from './api';

/**
 * Check the Promo Code
 */
export type PromoCodeResult = {
  code: string;
  reductionType: ReductionType;
  reductionPercent: number;
  valuePerKwh: number;
  partnerInformation?: {
    name: string;
    iconUrl: string;
    partnerFreeText: string;
    backgroundColor: string;
    fontColor: string;
  };
};

export const checkPromoCode = async ({
  code,
  language,
}: {
  code: string;
  language: string;
}): Promise<AxiosResponse<PromoCodeResult, any>> =>
  apiInstance.post(`/promoCode`, { code, language });
